import type {
  ConstructionFormState,
  LayeredConstructionCatalogItem,
  LayeredConstructionTechnology,
} from "../model/types";

import { findCatalogItemById } from "./configOptions";
import { buildLayerFormValues } from "./layers";

export const defaultConstructionFormState = (): ConstructionFormState => ({
  color: "",
  layers: [],
  typeName: "",
});

export const mapTechnologyToFormState = (
  technology?: LayeredConstructionTechnology | null,
  catalog: LayeredConstructionCatalogItem[] = []
): ConstructionFormState => {
  if (!technology) return defaultConstructionFormState();

  const catalogItem = findCatalogItemById(catalog, technology.typeDbId);
  const technologyLayers = buildLayerFormValues(technology);

  return {
    color: technology.color ?? "",
    layers: technologyLayers.length ? technologyLayers : [],
    typeName: String(catalogItem?.typeName ?? ""),
  };
};

export const applyCatalogItemToFormState = (
  state: ConstructionFormState,
  item: LayeredConstructionCatalogItem
): ConstructionFormState => ({
  ...state,
  layers: buildLayerFormValues(item),
  typeName: item.typeName,
});
